import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { ScreenContext } from '@/contexts/ScreenContext';
import { useRwdUI } from '@/hooks/useRwdUI';
import Box, { BoxProps } from '@mui/material/Box';
import { ReactNode, useCallback, useContext, useMemo } from 'react';

type RwdSvgIconOwnProps = {
    landscapeIconSize: number; //px
    portraitIconSize: number; //px
    children: ReactNode;
    onClick?: () => void;
    isOnClickSound?: boolean;
    isOnPointerCursor?: boolean;
};

type RwdSvgIconProps = RwdSvgIconOwnProps & BoxProps;

export const RwdSvgIcon = (props: RwdSvgIconProps) => {
    const {
        landscapeIconSize,
        portraitIconSize,
        children,
        onClick,
        isOnClickSound = false,
        isOnPointerCursor = false,
        ...otherProps
    } = props;
    const { pxToRwdCSSString } = useRwdUI();

    // const { isLandscape, scaleFactor } = useContext(ScreenContext);
    const { isLandscape } = useContext(ScreenContext);
    const { playButtonAudio } = useContext(AudioPlayContext);

    // const [rwdIconSize, setRwdIconSize] = useState<number>(1);

    // useEffect(() => {
    //     setRwdIconSize(isLandscape ? landscapeIconSize : portraitIconSize);
    // }, [isLandscape, scaleFactor]);
    const size = useMemo(
        () =>
            pxToRwdCSSString(
                isLandscape ? landscapeIconSize : portraitIconSize
            ),
        [isLandscape, landscapeIconSize, portraitIconSize]
    );

    const doOnClick = useCallback(() => {
        if (onClick) {
            if (isOnClickSound) {
                playButtonAudio();
            }
            onClick();
        }
    }, [onClick, isOnClickSound]);

    return (
        <Box
            width={size}
            height={size}
            display={'flex'}
            onClick={doOnClick}
            justifyContent={'center'}
            sx={{ cursor: isOnPointerCursor ? 'pointer' : 'default' }}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

export const RwdSvgIconInText = (props: RwdSvgIconProps) => {
    const {
        landscapeIconSize,
        portraitIconSize,
        children,
        onClick,
        isOnClickSound = false,
    } = props;
    const { pxToRwdCSSString } = useRwdUI();

    // const { isLandscape, scaleFactor } = useContext(ScreenContext);
    const { isLandscape } = useContext(ScreenContext);
    const { playButtonAudio } = useContext(AudioPlayContext);

    // const [rwdIconSize, setRwdIconSize] = useState<number>(1);

    // useEffect(() => {
    //     setRwdIconSize(isLandscape ? landscapeIconSize : portraitIconSize);
    // }, [isLandscape, scaleFactor]);
    const style = useMemo(() => {
        const size = pxToRwdCSSString(
            isLandscape ? landscapeIconSize : portraitIconSize
        );
        return {
            width: size,
            height: size,
            display: 'inline-block',
            verticalAlign: 'middle',
        };
    }, [isLandscape, landscapeIconSize, portraitIconSize]);

    const doOnClick = useCallback(() => {
        if (onClick) {
            if (isOnClickSound) {
                playButtonAudio();
            }
            onClick();
        }
    }, [onClick, isOnClickSound]);

    return (
        <span style={style} onClick={doOnClick}>
            {children}
        </span>
    );
};
